import styled from "styled-components";
const GroupSelectOption = ({
  selected,
  setSelected,
  value,
  contents,
  setContents,
  title,
}) => {
  return (
    <Div
      onClick={() => {
        setContents(contents);
        setSelected(value);
      }}
      selected={selected}
      value={value}
    >
      {title}
    </Div>
  );
};
export default GroupSelectOption;
const Div = styled.div`
  display: flex;
  justify-content: center;
  min-width: 4.5em;
  padding: 0.6em 1.2em;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 999px;
  color: ${({ selected, value, theme }) =>
    selected === value ? theme.colors?.foreground.inverted : theme.colors?.foreground.dimmed};
  background-color: ${({ selected, value, theme }) =>
    selected === value ? theme.colors?.dark : "transparent"};
  transition: background-color 0.2s, color 0.2s;
  &:hover {
    color: ${({ selected, value, theme }) =>
      selected === value ? theme.colors?.foreground.inverted : theme.colors?.accent};
  }
`;
